import JobOfferRequirement from './JobOfferRequirement';

export default JobOfferRequirement;
